import { useRouter, useMatchRoute } from '@tanstack/react-router';

// ----------------------------------------------------------------------

type ReturnType = boolean;

export function useActiveLinkTanstack(path: string, deep = true): boolean {
  const router = useRouter();
  const matchRoute = useMatchRoute();

  // Current path from TanStack Router
  const currentPath = router.state.location.pathname;

  // For external links
  if (path.includes('http')) {
    return false;
  }

  // For normal routes (exact match)
  const normalActive = path ? !!matchRoute({ to: path, fuzzy: false }) : false;

  // For deep/nested routes
  const deepActive = path
    ? !!matchRoute({ to: path, fuzzy: true }) || (path !== '/' && currentPath.startsWith(path))
    : false;

  return deep ? deepActive : normalActive;
}
